export enum MimeType {
	Video = 0,
	NotVideo = 1,
	All = 2
}

export enum BucketType {
	PreTask = 0,
	PreTask2 = 1,
	PreTask3 = 2,
	Lecture = 3,
	PostTask = 4,
	None
}

export enum TaskType {
	CheckTask,
	MakeReport,
	SubmitReport,
	CheckScore,
	JoinLecture,
	CheckLectureDocs,
	CheckLectureVideos,
	MakeTask, // Admin
	RegisterTask, // Admin
	RegisterReportFormat,
	ScoreReport, // Admin
	MakeLectureDocs, // Admin
	RegisterLectureDocs, // Admin
	GiveLecture, // Admin
	RegisterLectureVideos, // Admin
	None
}


export enum MsalResult {
	/**
	 * 成功
	 */
	Success = 0,
	/**
	 * 予期せぬエラー
	 */
	UnknownError = 1,
	/**
	 * 認証画面を表示したが何らかの原因で失敗した場合のエラー
	 */
	LoginPopupError = 2,
	/**
	 * アクセストークンをSilentで要求したが何らかの原因で失敗した場合のエラー
	 */
	AcquireTokenSilentError = 3,
	/**
	 * アクセストークンをPopupで要求したが何らかの原因で失敗した場合のエラー
	 */
	AcquireTokenPopupError = 4,
	/**
	 * userAgentApplication.getAccount() が false の場合のエラー
	 */
	AccountError = 5,
	/**
	 * MSALのAuthResponseがnullの場合のエラー
	 */
	AuthResponseNullError = 6,
	/**
	 * アクセストークンの要求が完了したがアクセストークンがnullの場合のエラー
	 */
	AccessTokenNullError = 7,
	/**
	 * パラメータエラー
	 */
	ParameterError = 8,
	/**
	 * インタラクションが必要
	 */
	InteractionRequiredError = 9,
	/**
	 * ログインリダイレクト中
	 */
	RedirectingToLogin = 10,
}

export enum ApiResult {
	Success = 0,
	UnknownError = 1,
	ResponseError = 2,
	ParseError = 3,
	ParameterError = 4,
	GraphApiError = 5,
}

export enum AccessTokenStatus {
	Valid = 0,
	Unknown = 1,
	EmptyOrUndefined = 2,
	FetchError = 4,
	ParseError = 5,
	InvalidAuthenticationToken = 6,
	AuthenticationError = 7,
	/**
	 * 期限切れ、動的な確認は accessTokenInfo.isExpired() を参照
	 */
	Expired = 8,
}
